(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["armas-foundation"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    const routes = window.ArmasRoutes || {};
    const money = (cents) => new Intl.NumberFormat(window.ArmasShop?.locale || 'en-PK', {style: 'currency', currency: window.ArmasShop?.currency || 'PKR', maximumFractionDigits: 0}).format((Number(cents) || 0) / 100);
    const toast = (message) => {
      let node = document.querySelector('.toast');
      if (!node) {
        node = document.createElement('div');
        node.className = 'toast';
        node.setAttribute('role', 'status');
        document.body.append(node);
      }
      node.textContent = message;
      node.dataset.visible = 'true';
      clearTimeout(node.timer);
      node.timer = setTimeout(() => node.dataset.visible = 'false', 2600);
    };
    const openDialog = (id) => {
      const dialog = document.getElementById(id);
      if (dialog && !dialog.open) dialog.showModal();
    };
    const closeDialog = (dialog) => {
      if (dialog?.open) dialog.close();
    };
    const updateCartCount = async () => {
      const response = await fetch(`${routes.cart}.js`, {headers: {'Accept': 'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = cart.item_count;
        node.hidden = cart.item_count === 0;
      });
    };
    const replaceCartDrawer = (html) => {
      if (!html) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const incoming = parsed.querySelector('#CartDrawerSection');
      const current = document.querySelector('#CartDrawerSection');
      if (incoming && current) current.replaceWith(incoming);
    };
    const addItem = async (variantId, quantity, trigger) => {
      if (!variantId || trigger?.disabled) return;
      if (trigger) {
        trigger.disabled = true;
        trigger.setAttribute('aria-busy', 'true');
      }
      try {
        const response = await fetch(`${routes.cartAdd}.js`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [{id: String(variantId), quantity: Number(quantity) || 1}], sections: 'armas-cart-drawer'})
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message);
        replaceCartDrawer(data.sections?.['armas-cart-drawer']);
        await updateCartCount();
        openDialog('CartDrawer');
        if (window.ttq?.track) window.ttq.track('AddToCart', {content_id: String(variantId), quantity: Number(quantity) || 1});
        if (window.fbq) window.fbq('track', 'AddToCart', {content_ids: [String(variantId)], content_type: 'product'});
        if (window.gtag) window.gtag('event', 'add_to_cart', {items: [{item_id: String(variantId), quantity: Number(quantity) || 1}]});
        toast(trigger?.dataset.addedText || 'Added to your bag');
      } catch (error) {
        const message = error.message || trigger?.dataset.errorText || 'This option could not be added.';
        toast(message);
        const form = trigger?.closest('form');
        const errorNode = form?.querySelector('[data-product-error]');
        if (errorNode) {
          errorNode.textContent = message;
          errorNode.hidden = false;
        }
      } finally {
        if (trigger) {
          trigger.disabled = false;
          trigger.removeAttribute('aria-busy');
        }
      }
    };
    const changeCart = async (id, quantity, trigger) => {
      if (trigger) trigger.disabled = true;
      try {
        const response = await fetch(`${routes.cartChange}.js`, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({id, quantity, sections: 'armas-cart-drawer'})
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message);
        replaceCartDrawer(data.sections?.['armas-cart-drawer']);
        document.querySelectorAll('[data-cart-count]').forEach((node) => {
          node.textContent = data.item_count;
          node.hidden = data.item_count === 0;
        });
      } catch (error) {
        toast(error.message || 'Your bag could not be updated.');
        if (trigger) trigger.disabled = false;
      }
    };
    const initProduct = (productRoot) => {
      const dataNode = productRoot.querySelector('[data-variants-json]');
      if (!dataNode) return;
      let variants = [];
      try { variants = JSON.parse(dataNode.textContent); } catch (error) { return; }
      const form = productRoot.querySelector('.js-product-form');
      const idInput = form?.querySelector('[name="id"]');
      const button = form?.querySelector('[type="submit"]');
      const price = productRoot.querySelector('[data-current-price]');
      const compare = productRoot.querySelector('[data-compare-price]');
      const lowStock = productRoot.querySelector('[data-low-stock]');
      const threshold = Number(productRoot.dataset.inventoryThreshold || 0);
      const stickyOption = document.querySelector('[data-sticky-option]');
      const stickyPrice = document.querySelector('[data-sticky-price]');
      const groups = Array.from(productRoot.querySelectorAll('[data-option-position]'));
      const selectedValues = () => groups.map((group) => group.querySelector('input:checked')?.value);
      const selectVariantOptions = (variant) => {
        if (!variant) return;
        groups.forEach((group, optionIndex) => {
          const input = Array.from(group.querySelectorAll('input')).find((item) => item.value === variant.options[optionIndex]);
          if (input) input.checked = true;
        });
      };
      const updateAvailability = () => {
        const selected = selectedValues();
        groups.forEach((group, optionIndex) => {
          group.querySelectorAll('input').forEach((input) => {
            const available = variants.some((item) => item.available && item.options.every((value, index) => index === optionIndex ? value === input.value : !selected[index] || value === selected[index]));
            input.disabled = !available;
            input.setAttribute('aria-disabled', String(!available));
          });
        });
      };
      const update = (changedInput) => {
        let selected = selectedValues();
        let variant = selected.length ? variants.find((item) => item.options.every((value, index) => value === selected[index])) : variants.find((item) => String(item.id) === idInput?.value);
        if (!variant?.available) {
          const changedGroup = changedInput?.closest('[data-option-position]');
          const changedIndex = changedGroup ? groups.indexOf(changedGroup) : -1;
          variant = changedIndex >= 0
            ? variants.find((item) => item.available && item.options[changedIndex] === changedInput.value)
            : variants.find((item) => item.available);
          selectVariantOptions(variant);
          selected = selectedValues();
        }
        updateAvailability();
        if (!variant) {
          if (button) {
            button.disabled = true;
            button.textContent = button.dataset.unavailableText;
          }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (price) price.textContent = money(variant.price);
        if (compare) {
          compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
          compare.hidden = !(variant.compare_at_price > variant.price);
        }
        if (button) {
          button.disabled = !variant.available;
          button.textContent = variant.available ? button.dataset.addText : button.dataset.soldText;
        }
        if (lowStock) {
          const quantity = Number(variant.inventory_quantity);
          const show = variant.available && variant.inventory_management && quantity > 0 && quantity <= threshold;
          lowStock.hidden = !show;
          if (show) lowStock.textContent = lowStock.dataset.template.replace('__COUNT__', quantity);
        }
        if (stickyOption) stickyOption.textContent = selected.filter(Boolean).join(' / ');
        if (stickyPrice) stickyPrice.textContent = money(variant.price);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
        if (variant.featured_media?.id) {
          const target = document.getElementById(`Media-${variant.featured_media.id}`);
          if (target && window.innerWidth < 761) target.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
        }
      };
      groups.forEach((group) => group.querySelectorAll('input').forEach((input) => input.addEventListener('change', () => update(input))));
      update();
      const observerTarget = form?.querySelector('[type="submit"]');
      const sticky = document.querySelector('[data-sticky-atc]');
      if (observerTarget && sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => sticky.dataset.visible = String(!entry.isIntersecting), {threshold: 0});
        observer.observe(observerTarget);
      }
    };
    const initPredictiveSearch = () => {
      document.querySelectorAll('[data-predictive-search]').forEach((container) => {
        const input = container.querySelector('input[type="search"]');
        const results = container.querySelector('[data-predictive-results]');
        if (!input || !results) return;
        let timer;
        input.addEventListener('input', () => {
          clearTimeout(timer);
          const term = input.value.trim();
          if (term.length < 2) {
            results.innerHTML = '';
            input.setAttribute('aria-expanded', 'false');
            return;
          }
          timer = setTimeout(async () => {
            const url = `${routes.predictiveSearch}?q=${encodeURIComponent(term)}&section_id=armas-predictive-search&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`;
            const response = await fetch(url);
            if (!response.ok) return;
            const html = await response.text();
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            results.innerHTML = parsed.querySelector('[data-search-fragment]')?.innerHTML || '';
            input.setAttribute('aria-expanded', results.textContent.trim() ? 'true' : 'false');
          }, 180);
        });
      });
    };
    const renderCollection = async (destination, updateHistory = true) => {
      const current = document.querySelector('[data-collection-section]');
      if (!current) {
        window.location.assign(destination);
        return;
      }
      const cleanUrl = new URL(destination, window.location.origin);
      const requestUrl = new URL(cleanUrl);
      requestUrl.searchParams.set('section_id', current.dataset.sectionId);
      current.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(requestUrl.toString(), {headers: {'X-Requested-With': 'XMLHttpRequest'}});
        if (!response.ok) throw new Error('Collection update failed');
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const incoming = parsed.querySelector('[data-collection-section]');
        if (!incoming) throw new Error('Collection section was not returned');
        incoming.querySelectorAll('[data-reveal]').forEach((node) => node.classList.add('is-visible'));
        current.replaceWith(incoming);
        applyCollectionGridPreferences(incoming);
        initInfiniteScroll(incoming);
        if (updateHistory) window.history.pushState({}, '', cleanUrl.toString());
        const status = document.querySelector('[data-collection-status]');
        const count = document.querySelector('.collection-count')?.textContent?.trim();
        if (status && count) status.textContent = count;
        document.querySelector('[data-collection-products]')?.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
      } catch (error) {
        window.location.assign(cleanUrl.toString());
      }
    };
    const applyCollectionGridPreferences = (scope = document) => {
      const sections = [];
      if (scope.matches?.('[data-collection-section]')) sections.push(scope);
      scope.querySelectorAll?.('[data-collection-section]').forEach((section) => sections.push(section));
      sections.forEach((section) => {
        let desktop = section.dataset.defaultDesktopColumns || '3';
        let mobile = section.dataset.defaultMobileColumns || '2';
        try {
          desktop = window.localStorage.getItem('armas-grid-desktop-v1') || desktop;
          mobile = window.localStorage.getItem('armas-grid-mobile-v1') || mobile;
        } catch (error) { /* Storage can be unavailable in privacy mode. */ }
        if (!['2', '3', '4'].includes(desktop)) desktop = '3';
        if (!['1', '2'].includes(mobile)) mobile = '2';
        const grid = section.querySelector('.product-grid--collection');
        if (grid) {
          grid.style.setProperty('--grid-columns', desktop);
          grid.style.setProperty('--grid-columns-mobile', mobile);
        }
        section.querySelectorAll('[data-grid-mode="desktop"]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.gridColumns === desktop)));
        section.querySelectorAll('[data-grid-mode="mobile"]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.gridColumns === mobile)));
      });
    };
    const initInfiniteScroll = (scope = document) => {
      const sentinels = [];
      if (scope.matches?.('[data-infinite-scroll]')) sentinels.push(scope);
      scope.querySelectorAll?.('[data-infinite-scroll]').forEach((sentinel) => sentinels.push(sentinel));
      sentinels.forEach((sentinel) => {
        if (sentinel.dataset.initialized === 'true') return;
        sentinel.dataset.initialized = 'true';
        const section = sentinel.closest('[data-collection-section]');
        const grid = section?.querySelector('.product-grid--collection');
        const pagination = section?.querySelector('.pagination');
        const status = sentinel.querySelector('[data-infinite-status]');
        if (!section || !grid || !sentinel.dataset.nextUrl) return;
        pagination?.classList.add('pagination--fallback-hidden');
        let loading = false;
        let observer;
        const loadNextPage = async () => {
          if (loading || !sentinel.dataset.nextUrl) return;
          loading = true;
          if (status) status.textContent = sentinel.dataset.loadingText || '';
          try {
            const nextUrl = new URL(sentinel.dataset.nextUrl, window.location.origin);
            const requestUrl = new URL(nextUrl);
            requestUrl.searchParams.set('section_id', section.dataset.sectionId);
            const response = await fetch(requestUrl.toString(), {headers: {'X-Requested-With': 'XMLHttpRequest'}});
            if (!response.ok) throw new Error('The next collection page could not be loaded');
            const html = await response.text();
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const incomingSection = parsed.querySelector('[data-collection-section]');
            const incomingGrid = incomingSection?.querySelector('.product-grid--collection');
            if (!incomingGrid) throw new Error('The next product grid was not returned');
            incomingGrid.querySelectorAll(':scope > .product-card').forEach((card) => {
              card.classList.add('is-visible');
              grid.append(card);
            });
            const incomingSentinel = incomingSection.querySelector('[data-infinite-scroll]');
            if (incomingSentinel?.dataset.nextUrl) {
              sentinel.dataset.nextUrl = incomingSentinel.dataset.nextUrl;
              if (status) status.textContent = '';
            } else {
              observer?.disconnect();
              pagination?.remove();
              sentinel.remove();
            }
          } catch (error) {
            if (status) status.textContent = sentinel.dataset.errorText || '';
            observer?.disconnect();
          } finally {
            loading = false;
          }
        };
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) loadNextPage();
          }, {rootMargin: '0px 0px 600px 0px'});
          observer.observe(sentinel);
        } else {
          loadNextPage();
        }
      });
    };
    const initProductShowcases = (scope = document) => {
      const showcases = [];
      if (scope.matches?.('[data-product-showcase]')) showcases.push(scope);
      scope.querySelectorAll?.('[data-product-showcase]').forEach((showcase) => showcases.push(showcase));
      showcases.forEach((showcase) => {
        if (showcase.dataset.initialized === 'true') return;
        const track = showcase.querySelector('[data-product-slider-track]');
        if (!track) return;
        showcase.dataset.initialized = 'true';
        const previous = showcase.querySelector('[data-product-slider-previous]');
        const next = showcase.querySelector('[data-product-slider-next]');
        const update = () => {
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
          if (previous) previous.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= maxScroll;
        };
        const move = (direction) => {
          const card = track.querySelector('.product-card');
          const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
          const distance = (card?.getBoundingClientRect().width || track.clientWidth) + gap;
          track.scrollBy({left: direction * distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        };
        previous?.addEventListener('click', () => move(-1));
        next?.addEventListener('click', () => move(1));
        track.addEventListener('scroll', update, {passive: true});
        showcase.addEventListener('armas:showcase:refresh', () => window.requestAnimationFrame(update));
        if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
        window.requestAnimationFrame(update);
      });
    };
    const hydrateHoverImage = (card) => {
      const image = card?.querySelector('[data-hover-image]');
      if (!image || image.getAttribute('src')) return;
      if (image.dataset.srcset) {
        image.setAttribute('srcset', image.dataset.srcset);
        image.removeAttribute('data-srcset');
      }
      if (image.dataset.src) {
        image.setAttribute('src', image.dataset.src);
        image.removeAttribute('data-src');
      }
    };
    const initRecentlyViewed = () => {
      const storageKey = 'armas-recently-viewed-v1';
      let items = [];
      try { items = JSON.parse(window.localStorage.getItem(storageKey) || '[]'); } catch (error) { items = []; }
      const currentNode = document.querySelector('[data-current-product]');
      let currentProduct = null;
      if (currentNode) {
        try { currentProduct = JSON.parse(currentNode.textContent); } catch (error) { currentProduct = null; }
      }
      if (currentProduct?.url) {
        items = [currentProduct, ...items.filter((item) => item?.url !== currentProduct.url)].slice(0, 12);
        try { window.localStorage.setItem(storageKey, JSON.stringify(items)); } catch (error) { /* Storage can be unavailable in privacy mode. */ }
        if (window.ttq?.track) window.ttq.track('ViewContent', {content_id: currentProduct.url, content_name: currentProduct.title});
        if (window.fbq) window.fbq('track', 'ViewContent', {content_ids: [currentProduct.url], content_name: currentProduct.title, content_type: 'product'});
        if (window.gtag) window.gtag('event', 'view_item', {items: [{item_id: currentProduct.url, item_name: currentProduct.title}]});
      }
      document.querySelectorAll('[data-recently-viewed]').forEach((section) => {
        const grid = section.querySelector('[data-recently-viewed-grid]');
        if (!grid) return;
        const limit = Number(section.dataset.limit || 4);
        const visibleItems = items.filter((item) => item?.url && item.url !== currentProduct?.url).slice(0, limit);
        grid.replaceChildren();
        visibleItems.forEach((item) => {
          const card = document.createElement('article');
          card.className = 'recent-card';
          const media = document.createElement('a');
          media.className = 'recent-card__media';
          media.href = item.url;
          media.setAttribute('aria-label', item.title || 'View product');
          if (item.image) {
            const image = document.createElement('img');
            image.src = item.image;
            image.alt = item.title || '';
            image.loading = 'lazy';
            image.width = 900;
            image.height = 600;
            media.append(image);
          }
          const content = document.createElement('div');
          content.className = 'recent-card__content';
          const title = document.createElement('h3');
          title.className = 'recent-card__title';
          const titleLink = document.createElement('a');
          titleLink.href = item.url;
          titleLink.textContent = item.title || '';
          title.append(titleLink);
          const price = document.createElement('span');
          price.className = 'recent-card__price';
          price.textContent = item.price || '';
          content.append(title, price);
          if (item.type) {
            const type = document.createElement('span');
            type.className = 'recent-card__type';
            type.textContent = item.type;
            content.append(type);
          }
          card.append(media, content);
          grid.append(card);
        });
        section.hidden = visibleItems.length === 0;
      });
    };
    document.addEventListener('click', (event) => {
      const gridButton = event.target.closest('[data-grid-columns]');
      if (gridButton) {
        const section = gridButton.closest('[data-collection-section]');
        const mode = gridButton.dataset.gridMode;
        const columns = gridButton.dataset.gridColumns;
        try { window.localStorage.setItem(`armas-grid-${mode}-v1`, columns); } catch (error) { /* Storage can be unavailable in privacy mode. */ }
        applyCollectionGridPreferences(section || document);
        return;
      }
      const collectionLink = event.target.closest('[data-collection-link], [data-tag-filter] a');
      if (collectionLink && document.querySelector('[data-collection-section]')) {
        event.preventDefault();
        renderCollection(collectionLink.href);
        return;
      }
      const opener = event.target.closest('[data-dialog-open]');
      if (opener) openDialog(opener.dataset.dialogOpen);
      const closer = event.target.closest('[data-dialog-close]');
      if (closer) closeDialog(closer.closest('dialog'));
      if (event.target.matches('dialog')) closeDialog(event.target);
      const quick = event.target.closest('[data-quick-add]');
      if (quick) addItem(quick.dataset.variantId, 1, quick);
      const quantityButton = event.target.closest('[data-quantity-change]');
      if (quantityButton) {
        const control = quantityButton.closest('[data-quantity-control]');
        const input = control?.querySelector('input');
        if (!input) return;
        const next = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(quantityButton.dataset.quantityChange));
        input.value = next;
      }
      const cartChange = event.target.closest('[data-cart-change]');
      if (cartChange) changeCart(cartChange.dataset.lineKey, Number(cartChange.dataset.quantity), cartChange);
      const sticky = event.target.closest('[data-sticky-submit]');
      if (sticky) document.querySelector('.js-product-form')?.requestSubmit();
    });
    document.addEventListener('submit', (event) => {
      const facetForm = event.target.closest('[data-facet-form]');
      if (facetForm) {
        event.preventDefault();
        const url = new URL(facetForm.action || window.location.href, window.location.origin);
        url.search = '';
        new FormData(facetForm).forEach((value, key) => {
          if (String(value).trim() !== '') url.searchParams.append(key, value);
        });
        url.searchParams.delete('page');
        renderCollection(url.toString());
        return;
      }
      const form = event.target.closest('.js-product-form');
      if (!form) return;
      event.preventDefault();
      const data = new FormData(form);
      addItem(data.get('id'), data.get('quantity') || 1, form.querySelector('[type="submit"]'));
    });
    document.addEventListener('change', (event) => {
      const sort = event.target.closest('[data-sort-select]');
      if (sort) {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        renderCollection(url.toString());
        return;
      }
      const autoSubmit = event.target.closest('[data-auto-submit]');
      if (autoSubmit) autoSubmit.form?.requestSubmit();
    });
    document.addEventListener('pointerover', (event) => hydrateHoverImage(event.target.closest('.product-card')));
    document.addEventListener('focusin', (event) => hydrateHoverImage(event.target.closest('.product-card')));
    const initialize = () => {
      root.classList.add('motion-ready');
      document.querySelectorAll('video img:not([alt])').forEach((image) => image.alt = '');
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        }), {rootMargin: '0px 0px -8% 0px'});
        document.querySelectorAll('[data-reveal]').forEach((node) => observer.observe(node));
      } else {
        document.querySelectorAll('[data-reveal]').forEach((node) => node.classList.add('is-visible'));
      }
      document.querySelectorAll('[data-product-root]').forEach(initProduct);
      applyCollectionGridPreferences();
      initInfiniteScroll();
      initProductShowcases();
      initPredictiveSearch();
      initRecentlyViewed();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) document.querySelectorAll('video[autoplay]').forEach((video) => video.pause());
    };
    window.addEventListener('popstate', () => {
      if (document.querySelector('[data-collection-section]')) renderCollection(window.location.href, false);
    });
    document.addEventListener('shopify:section:load', (event) => {
      initInfiniteScroll(event.target);
      initProductShowcases(event.target);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
    else initialize();
  })();
  } catch(e) { console.error(e); }
})();

})();
